import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { authService } from "../../../config";
import { useAppDispatch } from "../../redux/hooks";
import { getInitialAuthStateThunk } from "../../redux/thunks/auth/get-initial-auth-state-thunk";
import { ConfirmPasskeyStep } from "../passkey/ConfirmPasskeyStep";

export const SecondFactorStep = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const switchAccount = async () => {
    await authService.logout();
    await dispatch(getInitialAuthStateThunk());
  };

  return (
    <ConfirmPasskeyStep onConfirmed={() => void dispatch(getInitialAuthStateThunk())}>
      <Button mt="3" w="full" variant="ghost" onClick={() => void switchAccount()}>
        {t("Log in with another account")}
      </Button>
    </ConfirmPasskeyStep>
  );
};
